/** @format */

import React, { useEffect, useState } from "react";
import axios from "axios";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import SelectDropDown from "../Components/SelectDropdown";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import { titleList, firmsList } from "../data";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import LoadingButton from "@mui/lab/LoadingButton";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import SendIcon from "@mui/icons-material/Send";
import { useNavigate, NavLink } from "react-router-dom";
import "dayjs/locale/en-gb";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Avatar from "@mui/material/Avatar";
import Grid from "@mui/material/Grid";
import MultilineTextInput from "../Components/MultilineTextInput";

const AddUpdateApproveVendor = ({ vendorDetails = null }) => {
  const [loading, setLoading] = useState(false);
  const [oofice, setOofice] = useState(vendorDetails?.overseasOffice || "");
  const [aow, setAow] = useState(
    vendorDetails?.vendorBusinessDetails?.workshopAddress || ""
  );
  const [at, setAt] = useState(
    vendorDetails?.vendorFinDetails?.annualTurnover || ""
  );
  const [iso, setIso] = useState(
    vendorDetails?.vendorBusinessDetails?.isoCert ? "Yes" : "No" || "Yes"
  );
  const [tob, setTob] = useState(
    vendorDetails?.vendorBusinessDetails?.typeOfBusiness || "Manufacturer"
  );
  const [lis, setLis] = useState(
    vendorDetails?.vendorFinDetails?.listedInStock ? "Yes" : "No" || "Yes"
  );
  const [title, setTitle] = useState(vendorDetails?.title || "");
  const [firm, setFirm] = useState(
    vendorDetails?.vendorBusinessDetails?.typeOfFirm || ""
  );

  const [currencyList, setCurrencyList] = useState([]);

  const [currencyValue, setCurrencyValue] = useState(
    vendorDetails?.vendorFinDetails?.currency || ""
  );

  const [countrys, setCountrys] = useState([]);
  const [states, setStates] = useState([]);
  const [citys, setCitys] = useState([]);

  const [country, setCountry] = useState(vendorDetails?.country || "");
  const [state, setState] = useState(vendorDetails?.state || "");
  const [city, setCity] = useState(vendorDetails?.city || "");

  const [codeType, setCodeType] = useState(
    vendorDetails?.vendorFinDetails?.codeType || ""
  );

  console.log(vendorDetails);

  const navigate = useNavigate();

  async function updateVendorDetails(vdata) {
    setLoading(true)
    try {
      const updateResponse = await axios.put(
        `${process.env.REACT_APP_API_URL}/api/v1/vendor/update`,
        vdata,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(
              localStorage.getItem("accessToken")
            )}`,
          },
        }
      );
      console.log(updateResponse);
      setLoading(false)
      navigate("/dashboard")
      toast.success(`vendor profile successfully updated`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        });
    } catch (err) {
      setLoading(false)
      toast.error(`${err.message}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        });
      console.log(err);
    }
  }

  async function saveVendorDetails(vdata) {
    setLoading(true)
    try {
      const approveResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/vendor/save`,
        vdata
      );
      console.log(approveResponse);
      setLoading(false)
      navigate("/sign-in")
      toast.success(`vendor successfully created! Please contact admin for login credentials`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        });
    } catch (err) {
      setLoading(false)
      toast.error(`${err.message}`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        });
      console.log(err);
    }
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    console.log({
      vendorId: vendorDetails?.vendorId || null,
      sourceReference: data.get("source-reference"),
      title: data.get("title"),
      vendorName: data.get("name"),
      streetNo: data.get("house-no"),
      country: data.get("country"),
      addressLine1: data.get("address-line-1"),
      addressLine2: data.get("address-line-2"),
      addressLine3: data.get("address-line-3"),
      state: data.get("state/region"),
      city: data.get("city"),
      postalCode: data.get("postal-code"),
      poBoxNo: data.get("po-box-no"),
      vendorEmail: data.get("vendor-email"),
      telephoneNo1: data.get("telephone-no-1"),
      telephoneNo2: data.get("telephone-no-2"),
      mobileNo: data.get("mobile-no"),
      faxNo: data.get("fax-no"),
      contactPersonName: data.get("contact-person-name"),
      contactPersonNo: data.get("contact-person-no"),
      contactPersonDesignation: data.get("contact-person-designation"),
      contactPersonEmail: data.get("contact-person-email"),
      website: data.get("website"),
      overseasOffice: data.get("overseas-office"),
      vendorBusinessDetails: {
        isoCert: data.get("iso-certified") === "Yes" ? true : false,
        typeOfCert: data.get("type-of-certificate"),
        certValidity: data.get("validity-of-certificate"),
        issuingAuthority: data.get("issuing-authority"),
        certYear: data.get("year-of-certification"),
        typeOfFirm: data.get("type of firm"),
        typeOfBusiness: data.get("type-of-busness"),
        workshopAddress: data.get("address-of-workshop"),
        vendorId: vendorDetails?.vendorId || null,
      },
      vendorFinDetails: {
        bankName: data.get("bank-name"),
        beneficiaryAccountName: data.get("beneficiary-account-name"),
        beneficiaryAccountNum: data.get("beneficiary-account-number"),
        codeType: data.get("code type"),
        code: data.get("code"),
        accountNo: data.get("account-no"),
        address: data.get("address"),
        annualTurnover: data.get("annual-turnover"),
        currency: data.get("currency"),
        listedInStock: data.get("listed-in-stock") === "Yes" ? true : false,
        nameOfStock: data.get("name-of-stock"),
        vendorId: vendorDetails?.vendorId || null,
      },
    });

    const formVendorData = {
      vendorId: vendorDetails?.vendorId || null,
      sourceReference: data.get("source-reference"),
      title: data.get("title"),
      vendorName: data.get("name"),
      streetNo: data.get("house-no"),
      country: data.get("country"),
      addressLine1: data.get("address-line-1"),
      addressLine2: data.get("address-line-2"),
      addressLine3: data.get("address-line-3"),
      state: data.get("state/region"),
      city: data.get("city"),
      postalCode: data.get("postal-code"),
      poBoxNo: data.get("po-box-no"),
      vendorEmail: data.get("vendor-email"),
      telephoneNo1: data.get("telephone-no-1"),
      telephoneNo2: data.get("telephone-no-2"),
      mobileNo: data.get("mobile-no"),
      faxNo: data.get("fax-no"),
      contactPersonName: data.get("contact-person-name"),
      contactPersonNo: data.get("contact-person-no"),
      contactPersonDesignation: data.get("contact-person-designation"),
      contactPersonEmail: data.get("contact-person-email"),
      website: data.get("website"),
      overseasOffice: data.get("overseas-office"),
      vendorBusinessDetails: {
        isoCert: data.get("iso-certified") === "Yes" ? true : false,
        typeOfCert: data.get("type-of-certificate"),
        certValidity: data.get("validity-of-certificate"),
        issuingAuthority: data.get("issuing-authority"),
        certYear: data.get("year-of-certification"),
        typeOfFirm: data.get("type of firm"),
        typeOfBusiness: data.get("type-of-busness"),
        workshopAddress: data.get("address-of-workshop"),
        vendorId: vendorDetails?.vendorId || null,
      },
      vendorFinDetails: {
        bankName: data.get("bank-name"),
        beneficiaryAccountName: data.get("beneficiary-account-name"),
        beneficiaryAccountNum: data.get("beneficiary-account-number"),
        codeType: data.get("code type"),
        code: data.get("code"),
        accountNo: data.get("account-no"),
        address: data.get("address"),
        annualTurnover: data.get("annual-turnover"),
        currency: data.get("currency"),
        listedInStock: data.get("listed-in-stock") === "Yes" ? true : false,
        nameOfStock: data.get("name-of-stock"),
        vendorId: vendorDetails?.vendorId || null,
      },
    };

    if(data.get("beneficiary-account-number") !== data.get("re-input-beneficiary-account-number")){
      toast.error("Beneficiary account numbers should be same", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      })
      return;
    }

    vendorDetails === null
      ? saveVendorDetails(formVendorData)
      : updateVendorDetails(formVendorData);
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/v1/masterdata/getAllCountries`)
      .then((countris) => {
        console.log(countris.data.list);
        setCountrys(countris.data.list);
      })
      .catch((err) => console.log(err));
  }, []);

  const setStateByCountryId = async () => {
    console.log(country);
    const currentCountry = countrys.filter((item) => item.value === country);
    console.log(currentCountry);
    const currentCountryId = currentCountry[0].id;
    console.log(currentCountryId);
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/v1/masterdata/getAllStatesByCountry?countryId=${currentCountryId}`
    );
    setStates(res.data.list);
  };

  useEffect(() => {
    if (country === "") return;
    else setStateByCountryId();
  }, [country]);

  const setCityByStateId = async () => {
    console.log(state);
    const currentState = states.filter((item) => item.value === state);
    console.log(currentState);
    const currentStateId = currentState[0].id;
    console.log(currentStateId);
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/v1/masterdata/getAllCitiesByState?stateId=${currentStateId}`
    );
    setCitys(res.data.list);
  };

  async function getCurrencyList() {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/v1/masterdata/getAllCurrencies`
      );
      const currency_list = response.data.map((currency) => {
        return {
          name: currency.currencyName,
          value: currency.currency,
        };
      });
      setCurrencyList(currency_list);
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    if (state === "") return;
    else setCityByStateId();
  }, [state]);

  useEffect(() => {
    console.log(countrys);
  }, [countrys]);

  useEffect(() => {
    console.log(vendorDetails);
  }, [vendorDetails]);

  useEffect(() => {
    getCurrencyList();
  }, []);

  return (
    <>
      <Box
        sx={{
          marginTop: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
          {vendorDetails === null ? <HowToRegIcon /> : <AccountCircleIcon />}
        </Avatar>
        <Typography component="h1" variant="h5" sx={{ mb: 2 }}>
          {vendorDetails === null
            ? "Vendor Registration"
            : "Update Vendor Profile"}
        </Typography>

        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            mt: 1,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            minHeight: "72vh",
            gap: "20px",
          }}
        >
          <Card
            sx={{
              width: "90%",
              border: "1g solid primary.main",
              boxShadow:
                "0px 2px 5px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)",
            }}
          >
            <CardHeader
              title="General Details"
              sx={{
                color: "primary.dark",
                fontWweight: 400,
                fontSize: "1rem",
                lineHeight: "1.334",
              }}
            />
            <CardContent>
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  display="flex"
                  flexDirection="column"
                >
                  <TextField
                    margin="normal"
                    required
                    id="source-reference"
                    label="Source Reference"
                    name="source-reference"
                    defaultValue={vendorDetails?.sourceReference}
                  />
                  <SelectDropDown
                    options={titleList}
                    dropdownLabel="Title"
                    value={title}
                    setValue={setTitle}
                  />

                  <TextField
                    margin="normal"
                    required
                    id="street-house-no"
                    label="Street/House No"
                    name="house-no"
                    defaultValue={vendorDetails?.streetNo}
                  />
                  <TextField
                    margin="normal"
                    required
                    id="address-line-1"
                    label="Address Line 1"
                    name="address-line-1"
                    defaultValue={vendorDetails?.addressLine1}
                  />
                  <TextField
                    margin="normal"
                    id="address-line-2"
                    label="Address Line 2"
                    name="address-line-2"
                    defaultValue={vendorDetails?.addressLine2}
                  />
                  <TextField
                    margin="normal"
                    id="address-line-3"
                    label="Address Line 3"
                    name="address-line-3"
                    defaultValue={vendorDetails?.addressLine3}
                  />
                  <TextField
                    margin="normal"
                    id="po-box-no"
                    label="PO BOX No"
                    name="po-box-no"
                    defaultValue={vendorDetails?.poBoxNo}
                  />
                  <TextField
                    margin="normal"
                    required
                    id="telephone-no-1"
                    label="Telephone No 1"
                    name="telephone-no-1"
                    type="number"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue={vendorDetails?.telephoneNo1}
                  />
                  <TextField
                    margin="normal"
                    id="telephone-no-2"
                    label="Telephone No 2"
                    name="telephone-no-2"
                    type="number"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue={vendorDetails?.telephoneNo2}
                  />
                  <TextField
                    margin="normal"
                    required
                    id="contact-person-name"
                    label="Contact Person Name"
                    name="contact-person-name"
                    defaultValue={vendorDetails?.contactPersonName}
                  />
                  <TextField
                    margin="normal"
                    id="contact-person-designation"
                    label="Contact Person Designation"
                    name="contact-person-designation"
                    defaultValue={vendorDetails?.contactPersonDesignation}
                  />
                  <TextField
                    margin="normal"
                    id="website"
                    label="Website"
                    name="website"
                    defaultValue={vendorDetails?.website}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  display="flex"
                  flexDirection="column"
                  spacing={4}
                >
                  <TextField
                    margin="normal"
                    required
                    id="name"
                    label="Name Of Vendor"
                    name="name"
                    defaultValue={vendorDetails?.vendorName}
                  />
                  <SelectDropDown
                    options={countrys}
                    dropdownLabel="Country"
                    value={country}
                    setValue={setCountry}
                  />
                  <SelectDropDown
                    options={states}
                    dropdownLabel="State/Region"
                    value={state}
                    setValue={setState}
                  />
                  <SelectDropDown
                    options={citys}
                    dropdownLabel="City"
                    value={city}
                    setValue={setCity}
                  />
                  <TextField
                    margin="normal"
                    required
                    id="postal-code"
                    label="Postal Code"
                    name="postal-code"
                    type="number"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue={vendorDetails?.postalCode}
                  />
                  <TextField
                    margin="normal"
                    required
                    id="vendor-email"
                    label="Vendor E-mail"
                    name="vendor-email"
                    defaultValue={vendorDetails?.vendorEmail}
                  />
                  <TextField
                    margin="normal"
                    id="mobile-no"
                    label="Mobile No"
                    name="mobile-no"
                    type="number"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue={vendorDetails?.mobileNo}
                  />
                  <TextField
                    margin="normal"
                    id="fax-no"
                    label="Fax No"
                    name="fax-no"
                    type="number"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue={vendorDetails?.faxNo}
                  />
                  <TextField
                    margin="normal"
                    id="contact-person-no"
                    label="Contact Person No"
                    name="contact-person-no"
                    type="number"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    defaultValue={vendorDetails?.contactPersonNo}
                  />
                  <TextField
                    margin="normal"
                    id="contact-person-email"
                    label="Contact Person E-mail"
                    name="contact-person-email"
                    defaultValue={vendorDetails?.contactPersonEmail}
                  />
                  <MultilineTextInput
                    value={oofice}
                    setValue={setOofice}
                    label="Overseas Office"
                    name="overseas-office"
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>

          <Card
            sx={{
              width: "90%",
              border: "1g solid primary.main",
              boxShadow:
                "0px 2px 5px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)",
            }}
          >
            <CardHeader
              title="Business Details"
              sx={{
                color: "primary.dark",
                fontWweight: 400,
                fontSize: "1.2rem",
                lineHeight: "1.334",
              }}
            />
            <CardContent sx={{ display: "flex", flexDirection: "column" }}>
              <FormLabel id="demo-row-radio-buttons-group-label">
                Are you ISO certified?
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="iso-certified"
                value={iso}
                onChange={(e) => setIso(e.target.value)}
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
              </RadioGroup>
              <TextField
                margin="normal"
                id="type-of-certificate"
                label="Type of Certificate"
                name="type-of-certificate"
                variant="filled"
                defaultValue={vendorDetails?.vendorBusinessDetails?.typeOfCert}
              />
              <TextField
                margin="normal"
                id="validity-of-certificate"
                label="Validity-of-certificate"
                name="validity-of-certificate"
                variant="filled"
                defaultValue={
                  vendorDetails?.vendorBusinessDetails?.certValidity
                }
              />
              <TextField
                margin="normal"
                id=" issuing-authority"
                label="Issuing Authority"
                name="issuing-authority"
                variant="filled"
                defaultValue={
                  vendorDetails?.vendorBusinessDetails?.issuingAuthority
                }
              />

              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale="en-gb"
              >
                <DemoContainer components={["MobileDatePicker"]}>
                  <DemoItem label="Year of Certification">
                    <MobileDatePicker
                      name="year-of-certification"
                      views={["year"]}
                    />
                  </DemoItem>
                </DemoContainer>
              </LocalizationProvider>

              <SelectDropDown
                options={firmsList}
                dropdownLabel="Type of Firm"
                value={firm}
                setValue={setFirm}
              />

              <FormLabel
                id="demo-row-radio-buttons-group-label"
                sx={{ marginTop: "27px" }}
              >
                Type of Business
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="type-of-busness"
                value={tob}
                onChange={(e) => setTob(e.target.value)}
              >
                <FormControlLabel
                  value="Manufacturer"
                  control={<Radio />}
                  label="Manufacturer"
                />
                <FormControlLabel
                  value="Agent/Dealer"
                  control={<Radio />}
                  label="Agent/Dealer"
                />
                <FormControlLabel
                  value="Stockist"
                  control={<Radio />}
                  label="Stockist"
                />
                <FormControlLabel
                  value="Service Provider"
                  control={<Radio />}
                  label="Service Provider"
                />
                <FormControlLabel value="EPC" control={<Radio />} label="EPC" />
                <FormControlLabel
                  value="Supply & Service Provider"
                  control={<Radio />}
                  label="Supply & Service Provider"
                />
              </RadioGroup>
              <MultilineTextInput
                value={aow}
                setValue={setAow}
                label="Address of WorkShop(For Manufacturer) / Name & Address of Pricipal (For Agent/Dealer/Stockist)"
                name="address-of-workshop"
              />
            </CardContent>
          </Card>

          <Card
            sx={{
              width: "90%",
              border: "1px solid secondary.main",
              boxShadow:
                "0px 2px 5px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)",
            }}
          >
            <CardHeader
              title="Financial Information"
              sx={{
                color: "primary.dark",
                fontWweight: 400,
                fontSize: "1.2rem",
                lineHeight: "1.334",
              }}
            />
            <CardContent sx={{ display: "flex", flexDirection: "column" }}>
              <TextField
                margin="normal"
                required
                id="bank-name"
                label="Bank Name"
                name="bank-name"
                variant="standard"
                defaultValue={vendorDetails?.vendorFinDetails?.bankName}
              />
              <TextField
                margin="normal"
                required
                id="beneficiary-account-name"
                label="Beneficiary's Account Name"
                name="beneficiary-account-name"
                variant="standard"
                defaultValue={
                  vendorDetails?.vendorFinDetails?.beneficiaryAccountName
                }
              />
              <Box
                sx={{
                  mb: 2,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <TextField
                  fullWidth
                  margin="normal"
                  required
                  id="beneficiary-account-number"
                  label="Beneficiary's Account Number"
                  name="beneficiary-account-number"
                  variant="standard"
                  defaultValue={
                    vendorDetails?.vendorFinDetails?.beneficiaryAccountNum
                  }
                />
                {vendorDetails === null ? (
                  <TextField
                    fullWidth
                    margin="normal"
                    required
                    id="re-input-beneficiary-account-number"
                    label="Re-input Beneficiary's Account Number"
                    name="re-input-beneficiary-account-number"
                    variant="standard"
                  />
                ) : null}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <SelectDropDown
                  options={[
                    { name: "IFSC Code", value: "IFSC Code" },
                    { name: "Swift Code", value: "Swift Code" },
                  ]}
                  dropdownLabel="Code Type"
                  value={codeType}
                  setValue={setCodeType}
                />

                <TextField
                  fullWidth
                  margin="normal"
                  id="code"
                  label="Code"
                  name="code"
                  variant="standard"
                  defaultValue={vendorDetails?.vendorFinDetails?.code}
                />
              </Box>
              <TextField
                margin="normal"
                required
                id="account-no"
                label="Account No"
                name="account-no"
                variant="standard"
                defaultValue={vendorDetails?.vendorFinDetails?.accountNo}
              />

              <TextField
                id="outlined-multiline-static"
                label="Address"
                name="address"
                multiline
                rows={2}
                variant="filled"
                defaultValue={vendorDetails?.vendorFinDetails?.address}
                sx={{ margin: "10px 0 10px 0" }}
              />

              <MultilineTextInput
                value={at}
                setValue={setAt}
                label="Annual Turnover (Last 2 Years)"
                name="annual-turnover"
                rows={3}
              />
              <SelectDropDown
                options={currencyList}
                dropdownLabel="Currency"
                value={currencyValue}
                setValue={setCurrencyValue}
              />
              <FormLabel id="demo-row-radio-buttons-group-label" sx={{ mt: 2 }}>
                Listed in stock exchange?
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="listed-in-stock"
                sx={{ mb: 2 }}
                value={lis}
                onChange={(e) => setLis(e.target.value)}
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
              </RadioGroup>
              <TextField
                id="outlined-multiline-static"
                label="If listed please provide the name of stock exchange"
                multiline
                rows={3}
                name="name-of-stock"
                variant="filled"
                defaultValue={vendorDetails?.vendorFinDetails?.nameOfStock}
              />
            </CardContent>
          </Card>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: "column",
              gap: 1,
              mb: 3
            }}
          >
            <LoadingButton
              type="submit"
              loading={loading}
              variant="contained"
              loadingPosition="end"
              endIcon={<SendIcon />}
              sx={{ m: 1, bgcolor: "secondary.main" }}
            >
              {vendorDetails === null ? "Send" : "Update"}
            </LoadingButton>
            {vendorDetails === null && (
              <NavLink to="/sign-in" variant="body2">
                {"Already have an account? Sign in here!"}
              </NavLink>
            )}
          </Box>
        </Box>
      </Box>
      <ToastContainer />
    </>
  );
};

export default AddUpdateApproveVendor;
